import styled from 'styled-components';
import { TableRow } from 'components/Table';

export const TopMoversRow = styled(TableRow)<{ tableBodyRow?: boolean }>`
  grid-template-columns: repeat(6, minmax(0, 1fr));
`;
